import {
  type ItemLayouts,
  type StackItemLayout,
} from '@wix/document-services-types'

export function assertStackItemLayout(
  itemLayout: ItemLayouts | Record<string, unknown>,
): asserts itemLayout is StackItemLayout {
  const TYPE: StackItemLayout['type'] = 'StackItemLayout'
  if ('type' in itemLayout && itemLayout.type !== TYPE) {
    throw new Error('Not a stack-item layout.')
  }
}
